export const EMPLOYMENT_RETIRED = 'RETIRED';
export const EMPLOYMENT_UNEMPLOYED = 'UNEMPLOYED';
export const EMPLOYMENT_STUDENT = 'STUDENT';

/** 学生 / 待业 / 退休：公司明细不可填且须为空 */
const employmentDetailsLockedStatuses = new Set([
  EMPLOYMENT_STUDENT,
  EMPLOYMENT_UNEMPLOYED,
  EMPLOYMENT_RETIRED,
]);

export type JobStatusDetailForm = {
  employmentStatus: string;
  companyName: string;
  industry: string;
  industryOther: string;
  position: string;
  positionOther: string;
  companyAddress: string;
  employmentYears: string;
  companyPhone: string;
};

export const isEmploymentDetailsLocked = (status: string) =>
  employmentDetailsLockedStatuses.has(status);

export const clearEmploymentDetailFields = (form: JobStatusDetailForm) => {
  form.companyName = '';
  form.industry = '';
  form.industryOther = '';
  form.position = '';
  form.positionOther = '';
  form.companyAddress = '';
  form.employmentYears = '';
  form.companyPhone = '';
};

export const sanitizeEmploymentDetailFields = (form: JobStatusDetailForm) => {
  if (isEmploymentDetailsLocked(form.employmentStatus)) {
    clearEmploymentDetailFields(form);
  }
};
